module.exports = __webpack_public_path__ + "20250721160708/img/tiku.e7603b1a.png";